<template>
  <v-card
    flat
    outlined
  >
    <v-card-title>Before Submitting an Issue</v-card-title>

    <v-card-text>
      <p>
        This form is for submitting new issues to
        <a
          href="https://www.github.com/vuetifyjs?ref=issues.vuetifyjs.com"
          target="_blank"
        >
          Vuetify.js
          <v-icon
            color="primary"
            x-small
            v-text="'mdi-open-in-new'"
          />
        </a> repositories. If you're just looking for help, try asking the
        <a
          href="https://community.vuetifyjs.com?ref=issues.vuetifyjs.com"
          target="_blank"
        >
          community
          <v-icon
            color="primary"
            x-small
            v-text="'mdi-open-in-new'"
          />
        </a>
      </p>

      <ul>
        <li>
          Search the repo and ensure your issue doesn't already exist. If so, it may:
          <ul>
            <li>Have already been fixed in an unreleased version.</li>

            <li>Have been closed without a solution. Please create a new issue instead of commenting on the old one.</li>
          </ul>
        </li>

        <li>
          Create a minimal reproduction to illustrate the issue. You can use a
          <!-- <a
            href="https://template.vuetifyjs.com"
            target="_blank"
          >
            Vuetify 2.x CodePen template
            <v-icon
              color="primary"
              x-small
              v-text="'mdi-open-in-new'"
            />
          </a>
          or -->
          <a
            href="https://play.vuetifyjs.com/"
            target="_blank"
          >
            Vuetify 3.x playground
            <v-icon
              color="primary"
              x-small
              v-text="'mdi-open-in-new'"
            />
          </a>.
          <!-- <ul>
            <li>
              If you need a full project to reproduce, consider <a
                href="https://codesandbox.io/s/vue"
                target="_blank"
              >
                Vuetify 2.x CodeSandbox
                <v-icon
                  color="primary"
                  x-small
                  v-text="'mdi-open-in-new'"
                />
              </a>
            </li>

            <li>
              If you need a reproduction with router, consider
              <a
                href="https://codepen.io/johnjleider/pen/PMZvpr"
                target="_blank"
              >
                Vuetify 2.x Router Template
                <v-icon
                  color="primary"
                  x-small
                  v-text="'mdi-open-in-new'"
                />
              </a>
            </li>
          </ul> -->
        </li>
      </ul>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'InformationBox',
  }
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
</style>
